import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useTranslation } from '../hooks/useTranslation';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background: #000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const Title = styled.h1`
  font-size: 140px;
  font-weight: 200;
  color: #fff;
  margin: 0 0 32px 0;
  letter-spacing: 0.3em;
  text-transform: uppercase;
  animation: ${fadeIn} 1s ease-out;
`;

const Subtitle = styled.p`
  font-size: 32px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
  letter-spacing: 0.1em;
  animation: ${fadeIn} 1s ease-out 0.5s both;
`;

/**
 * WelcomeScreen - Welcome text display for secondary screens
 *
 * Shows "KUUTIO" with workshop welcome subtitle.
 * Used on secondary screens (A2, B2, C2, D2) while primary shows rotating cube.
 */
const WelcomeScreen = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Title>KUUTIO</Title>
      <Subtitle>{t('welcome.subtitle')}</Subtitle>
    </Container>
  );
};

export default WelcomeScreen;
